import { TrelloReconnectButton } from './TrelloReconnectButton';
export const TrelloReconnectionConfig = {
  reconnectButton: TrelloReconnectButton
};